import { PageController } from '@client/components/_core/layout/PageController';
import { TransactionTypeEdit } from '@client/components/claims/financials/TransactionTypeEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/add',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'New transaction type',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <TransactionTypeEdit action={['add']} />
        </PageController>
    );
}
